/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Compare from '../Compare'
import ListtingCompare from '../ListtingCompare'
import ListtingAllCompare from '../ListtingAllCompare'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/cross-checks',
    name: 'cross-check',
    component: Compare,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/cross-checks/listting/:id',
    name: 'listting-compare',
    component: ListtingCompare,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/compares',
    name: 'compare',
    component: ListtingAllCompare,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/compare/routes/index.js